import Immutable from 'immutable';

export interface RawPoint {
  points: number[];
}

export interface PointData {
  points: number[];
}

const defaultValues: PointData = {
  points: [],
};

export const PointFactory = Immutable.Record(defaultValues, 'Point');

export class Point extends PointFactory {
  static deserialize(rawPoint: RawPoint): Point {
    return new Point({
      ...rawPoint,
    });
  }

  serialize(): RawPoint {
    return this.toJS();
  }
}
